// @flow
import * as React from 'react';
import {
  SelectedProductLinkContext,
  AccordionInGridContext,
} from 'routes/RouteProvider';

export type WithSelectedProductLinkInjectedProps = {|
  +selectedProductLink: string | null,
  +accordionInGrid: boolean,
|};

function withSelectedProductLink<OwnProps>(
  WrappedComponent: React.AbstractComponent<{|
    ...OwnProps,
    ...WithSelectedProductLinkInjectedProps,
  |}>
): React.AbstractComponent<OwnProps> {
  function WithSelectedProductLink(props) {
    return (
      <SelectedProductLinkContext.Consumer>
        {(selectedProductLink) => (
          <AccordionInGridContext.Consumer>
            {(accordionInGrid) => (
              <WrappedComponent
                selectedProductLink={selectedProductLink}
                accordionInGrid={accordionInGrid}
                {...props}
              />
            )}
          </AccordionInGridContext.Consumer>
        )}
      </SelectedProductLinkContext.Consumer>
    );
  }
  return WithSelectedProductLink;
}

export default withSelectedProductLink;
